import React, {Component} from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";

class TeamingButton extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            numTeamers: undefined
        }
        
    }
    
    render() {
        const {nombre, teaming} = this.props;
        const show = teaming != null || teaming.trim() !== ""
        
        let textTeamers
        if (this.state.numTeamers) {
            if (this.state.numTeamers === 0) {
                textTeamers = "Se el primero en ayudarles"
            } else {
                textTeamers = this.state.numTeamers + " personas ya lo han hecho"
            }
        } else {
            textTeamers = "Únete a su grupo"
        }
        let urlTeaming = teaming.url
        if (!/^((ftp|http|https):\/\/)/img.test(urlTeaming)) {
            urlTeaming = "https://" + urlTeaming
        }
        return (
            <div className="">
                {show &&
                    <div className="divTeaming">
                        <div className="teamingButton">
                                <a onClick={this.props.onClick} className="teamingImg" href={urlTeaming} target="_blank"
                                   rel="nofollow">
                                    <LazyLoadImage threshold={150}
                                                   src={process.env.CDN_URL + "/images/adoptaunanimal/social/logotipo_teaming.png"}/>
                                </a>
                            <div className="tooltip">
                                {(nombre) ? "Ayuda a " + nombre : "Unete"} por solo 1€/mes
                                <span className="tooltiptext-left">
                                    Teaming es una herramienta online para recaudar fondos para causas sociales a través de donaciones de 1€/mes. La cantidad vas destinada integramente para {(nombre) ? nombre : "la protectora o asociación"}. Adoptar un animal® no se queda nada de la donación
                                </span>
                            </div>
                            <div className="textTeaming">
                                <span className="teamingTextIcon las la-user-check"/>{textTeamers}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
    
    componentDidMount() {
        if (this.props.teaming && this.props.teaming.url != null && !this.state.numTeamers) {
            const that = this;
            $.ajax({
                    type: 'GET',
                    url: "/api/utils/teamingData",
                    dataType: "json",
                    data: {
                        url: this.props.teaming.url
                    },
                })
                .done((response, textStatus, jqXHR) => {
                    that.setState({
                        numTeamers: response.numTeamers
                    })
                })
                .fail((jqXHR, textStatus, errorThrown) => {
                    let errorStr;
                    if (typeof jqXHR.responseJSON === "object" && Array.isArray(jqXHR.responseJSON)) {
                        errorStr = jqXHR.responseJSON.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                    } else {
                        errorStr = jqXHR.responseJSON;
                    }
                
                    if (console && console.log) {
                        //console.log("La solicitud a fallado: " + errorStr);
                    }
                });
        }
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.numTeamers && prevState.numTeamers !== this.state.numTeamers) {
            this.props.onShowButton()
        }
    }
}

export default TeamingButton;
